<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="阴阳性统计" >
        </FormItem>
        <!-- <FormItem label="开始时间" >
          <Col span="12">
            <DatePicker
              type="date"
              @on-change="table.search.begintime = $event"
              v-model="table.search.begintime"
              placeholder="选择开始时间"
            ></DatePicker>
          </Col>
        </FormItem>
        <FormItem label="结束时间">
          <Col span="12">
            <DatePicker
              type="date"
              @on-change="table.search.endtime = $event"
              v-model="table.search.endtime"
              placeholder="选择结束时间"
            ></DatePicker>
          </Col>
        </FormItem> -->
        <FormItem label="机构名称">
          <Input placeholder="请输入" v-model="table.search.ExamOrgan"></Input>
        </FormItem>
        <!-- <FormItem label="检查类型">
          <Select placeholder="请选择" v-model="table.search.DicCode" class="w-250" clearable> 
            <Option
              v-for="(item, index) in ExamTypeSelect"
              :value="item.dictionaryValue"
              :key="index"
              >{{ item.dictionaryValue }}</Option
            >
          </Select>
        </FormItem> -->
      </Form>
      <div>
          <Button class="mr-3" type="success" @click="search">查询</Button>
          <!-- <Button class="mr-3" type="primary" @click="exportExcel">导出</Button> -->
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
    ></DataTable>
    <!-- 弹框11 -->
    <Modal
        v-model="modal1"
        title="详情"
        width="1200px"
        @on-ok="ok"
        @on-cancel="cancel">
        <Form :label-width="90" inline>
          <FormItem label="检查号">
            <Input placeholder="请输入" v-model="Modal_form.AccessionNumber"></Input>
          </FormItem>
          <FormItem label="病例号">
            <Input placeholder="请输入" v-model="Modal_form.MedCaseNO"></Input>
          </FormItem>
          <FormItem label="患者姓名">
            <Input placeholder="请输入" v-model="Modal_form.PatientName"></Input>
          </FormItem>
          <FormItem label="">
            <Button class="mr-3" type="success" @click="search_madal2(Modal_form)">查询</Button>
          </FormItem>
         </Form>
         <!-- <div>
           <Button class="mr-3" type="success" @click="search">查询</Button>
         </div> -->
        <Table
          :loading="loading"
          border
          stripe 
          :columns="columns1"
          :data="data1"
          size="small"
          :height="0"
          disabled-hover
          highlight-row
        ></Table>

        <!-- 这里只是危急值详情 分页 -->
         <div class="mt-2 page_out">
        <Page
          :total="pagination.total"
          :current="pagination.search.PageIndex"
          :page-size-opts="pagination.sizes"
          :page-size="pagination.search.PageSize"
          show-elevator
          show-sizer
          show-total
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
        />
         <!-- <Page :total="100"></Page> -->
      </div>
          <!-- @on-selection-change="selectionChange"
          @on-row-click="onRowClick" -->
          <div slot="footer"></div>
    </Modal>
    <!-- 弹框33 -->
    <Modal
      v-model="modal2"
      title="详情"
      width="1200px"
      @on-ok="ok"
      @on-cancel="cancel">
        <p class="ppp">患者姓名:{{data3.patientName}}</p>
        <p class="ppp">年龄:{{data3.patientAge}}</p>
        <p class="ppp">检查医生:{{data3.reportDR}}</p>
        <p class="ppp">检查时间:{{data3.reportDate}}</p>
        <p class="ppp">审核医生:{{data3.verifyDR}}</p>
        <p class="ppp">审核时间:{{data3.verifyDate}}</p>
        <p class="ppp">检查所见:{{data3.findings}}</p>
        <p class="ppp">检查报告:{{data3.diagnosis}}</p>
        <div slot="footer"></div>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable_report.vue";
// import DataTable from "@/components/NoPageDataTable.vue";

export default {
  components: { DataTable },
  data: function () {
    return {
      // 新增
      Modal_form:{
        AccessionNumber:'',
        MedCaseNO:'',
        PatientName:'',
        ExamOrganCode:'', //机构编号
        reportResult:'', //阴阳
      },
       DicSelect: ['测试医院1','测试医院2'],
      //  ExamTypeSelect:['测试CT','测试MG','测试DX'],
       ExamTypeSelect:[],
        modal1: false,
        modal2: false,
        para_load:null,
        para_load_yinyang:null,
        // 这里只是危急值详情 分页数据
        pagination: {
          total: 0,
          sizes: [10, 20, 30, 50],
          search: {
            PageIndex: 1,
            // PageIndex_show: 1,
            PageSize: 10,
          },
      },
         columns1: [
              {
                  title: '检查号',
                  key: 'accessionNumber'
              },
              {
                  title: '病例号',
                  key: 'medCaseNO'
              },
              {
                  title: '患者姓名',
                  key: 'patientName'
              },
              {
                  title: '联系方式',
                  key: 'telePhone'
              },
              {
                  title: '检查机构',
                  key: 'examOrgan'
              },
              {
                  title: '阴阳性',
                  key: 'reportResult',
                  render: (h, params) => {
                      return h('div', 
               [
                 
                  h('div',{
                    // prop:{type:},
                    style: {
                      display:'inline-block',
                      margin:'0px 10px 0 0px',
                      textAlign: 'center',
                      width: '10px',
                      height: '10px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      background: `${params.row.reportResult == 1?'red':'rgb(135, 208, 104)'}`,
                      radius:' 50%'
                    }

                  }),
                   h('strong',params.row.reportResult == 1?'阳性':'阴性'),
               ],)
                      // },params.row.reportResult);
                  }
              },
             
              {
                  title: '操作',
                  key: 'criticalValue',
                   render: (h, params) => {
                      return h('div', {
                          style: {
                            color: '#2d8cf0',
                            width: '50px',
                            height: '20px',
                            cursor: 'pointer',
                          // background: "red"
                          },
                          on: {
                              click: () => {
                                  console.log('点击数量',params)
                                  this.modal2 = true
                                  this.table3(params.row)
                              }
                          }
                      // }, `${params.row.criticalValue}`);
                      }, `查看`);
                  }
              },
          ],
         columns3: [
              {
                  title: '患者姓名',
                  key: 'patientName'
              },
              {
                  title: '年龄',
                  key: 'patientAge'
              },
              {
                  title: '检查医生',
                  key: 'reportDR'
              },
              {
                  title: '检查时间',
                  key: 'reportDate'
              },
              {
                  title: '审核医生',
                  key: 'verifyDR'
              },
              {
                  title: '审核时间',
                  key: 'verifyDate'
              },
              {
                  title: '检查所见',
                  key: 'findings',
                  
              },
              {
                  title: '诊断报告',
                  key: 'diagnosis',
                  
              },
          ],
          loading: false,
          data1: [],
          data3: {},

      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "机构名称", key: "examOrgan" },
          { title: `阳性`, key: "reportResult1" ,
            renderHeader:(h, params) =>{
               return h('div', 
               [
                 
                  h('div',{
                    // prop:{type:},
                    style: {
                      display:'inline-block',
                      margin:'0px 10px 0 0px',
                      textAlign: 'center',
                      width: '10px',
                      height: '10px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      background: 'red',
                      radius:' 50%'
                    }

                  }),
                   h('strong','阳性'),
               ],)
            },
            render: (h, params) => {
                return h('div', 
                
                  {
                    style: {
                      color: '#2d8cf0',
                      width: '50px',
                      height: '20px',
                      cursor: 'pointer',
                    },
                    on: {
                        click: () => {
                            console.log('点击数量',params)
                             this.pagination.search.PageIndex = 1
                             this.pagination.search.PageSize = 10
                            this.modal1 = true
                            this.table2(params.row,1)
                        }
                    }
                }, `${params.row.reportResult1}`);
            }
          },
          { title: "阴性", key: "reportResult0" ,
          renderHeader:(h, params) =>{
               return h('div', 
               [
                  h('div',{
                    // prop:{type:},
                    style: {
                      display:'inline-block',
                      margin:'0px 10px 0 0px',
                      textAlign: 'center',
                      width: '10px',
                      height: '10px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      background: 'rgb(135, 208, 104)',
                      radius:' 50%'
                    }

                  }),
                   h('strong','阴性'),
               ],)
            },
            render: (h, params) => {
                return h('div', {
                    style: {
                      color: '#2d8cf0',
                      width: '50px',
                      height: '20px',
                      cursor: 'pointer',
                    },
                    on: {
                        click: () => {
                            console.log('点击数量',params)
                             this.pagination.search.PageIndex = 1
                             this.pagination.search.PageSize = 10
                            this.modal1 = true
                            this.table2(params.row,0)
                        }
                    }
                }, `${params.row.reportResult0}`);
            }
          },
          
        ],
        // apiUrl: "datastatistics/getStatisticsByHosptialExamTypeList",
        apiUrl: "client/yinyang",  //阴阳统计
        search: {
          ExamOrgan: "",
          begintime: "",
          endtime: "",
          DicCode:''
        },
      },
    };
  },

  activated: function () {
    const date = new Date();
    const years = date.getFullYear();
    const today = date.getDate();
    const currentMonth_begin = date.getMonth() ;
    const currentMonth_end = date.getMonth() + 1;
    const all_data_begin = years + '-' + currentMonth_begin + '-'+ today
    const all_data_end = years + '-' + currentMonth_end + '-'+ today
    this.table.search.begintime = '2021-4-7' //all_data_begin
    this.table.search.endtime = all_data_end
    console.log('时间',this.table.search);


    this.clientLogTypeSelect = this.$common.getJsonData("clientLogType");
    let organCode = localStorage.getItem("organCode");
    let userType = localStorage.getItem("userType");
      console.log('organCode',organCode);
    if (!userType.indexOf("管理员")) {
      this.table.search.ExamOrganCode = organCode;
    }

    //获取检查类型数据 
    //  var _this = this;
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      // console.log('data数据',data);
      this.ExamTypeSelect = data;
    });
    this.$refs.dataTable.initload();
  },

  methods: {
    // 新增
     ok () {
        // this.$Message.info('点击了确定');
    },
    cancel () {
        // this.$Message.info('点击了取消');
    },
    search_madal2(para){
      console.log('表二查询',para);
      this.$api.get(`client/yinyangList?ExamOrganCode=${para.ExamOrganCode}&ReportResult=${para.reportResult}&AccessionNumber=${para.AccessionNumber}&MedCaseNO=${para.MedCaseNO}&PatientName=${para.PatientName}&PageIndex=1&pageSize=10`).then((rsp) => {
      // this.$api.get(`client/criticallist?examOrganCode=${para.examDepartment}&reportResult=${yinyang}&PageIndex=${this.pagination.search.PageIndex}&pageSize=${this.pagination.search.PageSize}`).then((rsp) => {
        if (rsp != false) {
          this.data1= rsp.data.item1;
           this.pagination.total = rsp.data.item2;
          console.log('请求的表格22数据',this.data1);
          // this.loading = false;
        }
      });
    },
    //分页
    pageChange: function (page) {
       this.pagination.search.PageIndex = page;
      this.table2(this.para_load,this.para_load_yinyang);
    },
    sizeChange: function (size) {
      this.pagination.search.PageSize = size;
      this.table2(this.para_load,this.para_load_yinyang);
    },
    //请求弹框2 的表中数据 阴阳性
    table2(para,yinyang,Accession){
      console.log('阴阳性',para,yinyang,Accession);
      // if (yinyang==1) {
      //   console.log('阳');
      // } else if(yinyang==0){
      //   console.log('阴');
        
      // }
      this.Modal_form.ExamOrganCode = para.examOrganCode
      this.Modal_form.reportResult = yinyang

      this.para_load = para
      this.para_load_yinyang = yinyang
      // this.$api.get(`client/yinyangList?examOrganCode=${para.examOrganCode}&reportResult=${yinyang}`).then((rsp) => {
      this.$api.get(`client/yinyangList?examOrganCode=${para.examOrganCode}&reportResult=${yinyang}&PageIndex=${this.pagination.search.PageIndex}&pageSize=${this.pagination.search.PageSize}`).then((rsp) => {
        if (rsp != false) {
          this.data1= rsp.data.item1;
           this.pagination.total = rsp.data.item2;
          console.log('请求的表格22数据',this.data1);
          // this.loading = false;
        }
      });
     
    },
    //请求弹框3 的表中数据 
    table3(para){
      console.log('cdd',para);
      this.data3 = []
      this.$api.get(`client/criticalinfo?AccessionNumber=${para.accessionNumber}`).then((rsp) => {
      // this.$api.get(`client/criticallist?ExamDepartment=中医科（皮肤科）&ExamTypeName=ECG&PageIndex=0&pageSize=10`).then((rsp) => {
        if (rsp != false) {
          this.data3= rsp.data[0];
          console.log('请求的表格33数据',this.data3);
          // this.loading = false;
        }
      });
    },
    
    search: function () {
      // this.$refs.dataTable.initload();
      this.$refs.dataTable.initload();
      console.log('时间',this.table.search);
    },
    // 导出Excel
    exportExcel: function () {
      var urls ="/"+ this.table.apiUrl + "exportExcel?";
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + urls + params;
      console.log(url);
      window.open(url);
    },
    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
.page_out{
    width: 100%;
    text-align: right;
  }
.ppp{
  /* border: 1px red solid; */
  margin-bottom: 8px;
}
</style>